/**
 * Penner easing curves as `[x1, y1, x2, y2]` tuples for motion/react.
 *
 * Mirrors the `--ease-*` CSS variables in `styles/theme.css` — keep both
 * in sync if values change.
 *
 * Usage:
 *   import { animate } from "motion/react";
 *   import { easings } from "@shared/utils";
 *   animate(0, 1, { ease: easings.outQuint, duration: 0.6 });
 */

export type EasingTuple = readonly [number, number, number, number];

export const easings = {
    inQuad: [0.55, 0.085, 0.68, 0.53] as const,
    inCubic: [0.55, 0.055, 0.675, 0.19] as const,
    inQuart: [0.895, 0.03, 0.685, 0.22] as const,
    inQuint: [0.755, 0.05, 0.855, 0.06] as const,
    inExpo: [0.95, 0.05, 0.795, 0.035] as const,
    inCirc: [0.6, 0.04, 0.98, 0.335] as const,

    outQuad: [0.25, 0.46, 0.45, 0.94] as const,
    outCubic: [0.215, 0.61, 0.355, 1] as const,
    outQuart: [0.165, 0.84, 0.44, 1] as const,
    outQuint: [0.23, 1, 0.32, 1] as const,
    outExpo: [0.19, 1, 0.22, 1] as const,
    outCirc: [0.075, 0.82, 0.165, 1] as const,

    inOutQuad: [0.455, 0.03, 0.515, 0.955] as const,
    inOutCubic: [0.645, 0.045, 0.355, 1] as const,
    inOutQuart: [0.77, 0, 0.175, 1] as const,
    inOutQuint: [0.86, 0, 0.07, 1] as const,
    inOutExpo: [1, 0, 0, 1] as const,
    inOutCirc: [0.785, 0.135, 0.15, 0.86] as const
} satisfies Record<string, EasingTuple>;
